enum ActivityStatus {
  WaitingAssignment = "WAITING_ASSIGNMENT",
  Development = "DEVELOPMENT",
  Assigned = "ASSIGNED",
  Canceled = "CANCELED",
  Executed = "EXECUTED",
  Active = "ACTIVE",
}

export default ActivityStatus;
